<template>
  <div class="coming-soon">
    <v-icon size="56" color="primary">mdi-clock-outline</v-icon>
    <p class="coming-soon__text">Próximamente...</p>
  </div>
</template>

<script>
export default {
  name: "ComingSoon",
};
</script>

<style scoped>
.coming-soon {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  padding: 24px;
  text-align: center;
}
.coming-soon__text {
  margin: 16px 0 0;
  font-family: "Artificial Intelligence", sans-serif;
  font-size: 28px;
  font-weight: 600;
  color: #0f172a;
}
</style>
